import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supervisor-menu',
  templateUrl: './supervisor-menu.component.html',
  styleUrls: ['./supervisor-menu.component.css']
})
export class SupervisorMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
